import React from 'react';

const STATUS_CLASS_MAP = {
  Completed: 'bootcamp-status-success',
  Incomplete: 'bootcamp-status-warning',
  'Missing Capstone': 'bootcamp-status-info',
  'Pending Capstone Review': 'bootcamp-status-review',
  'Pending Manager Review': 'bootcamp-status-review',
  Registered: 'bootcamp-status-registered',
  'No Show': 'bootcamp-status-muted',
  Failed: 'bootcamp-status-danger',
};

const BootcampIndividualStatusTab = ({
  statusSummary,
  rows,
  paginationMeta,
  page,
  onPageChange,
  isLoading,
  errorMessage,
}) => {
  const safeSummary = statusSummary || {};
  const safeRows = Array.isArray(rows) ? rows : [];
  const safeMeta = paginationMeta || { page: 1, pageSize: 15, totalItems: 0, totalPages: 1 };
  const currentPage = safeMeta.page || page || 1;
  const pageSize = safeMeta.pageSize || 15;
  const totalItems = safeMeta.totalItems || 0;
  const totalPages = safeMeta.totalPages || 1;
  const start = totalItems === 0 ? 0 : (currentPage - 1) * pageSize + 1;
  const end = totalItems === 0 ? 0 : Math.min(currentPage * pageSize, totalItems);
  const hasRows = safeRows.length > 0;
  const showInitialLoading = isLoading && !hasRows;

  return (
    <div className="bootcamp-individual">
      <div className="bootcamp-chip-grid">
        <span className="bootcamp-chip">Total {safeSummary.total || 0}</span>
        <span className="bootcamp-chip">Completed {safeSummary.completed || 0}</span>
        <span className="bootcamp-chip">Incomplete {safeSummary.incomplete || 0}</span>
        <span className="bootcamp-chip">Missing Capstone {safeSummary.missingCapstone || 0}</span>
        <span className="bootcamp-chip">Pending Manager Review {safeSummary.pendingManagerReview || 0}</span>
        <span className="bootcamp-chip">
          Pending Capstone Review {safeSummary.pendingCapstoneReview || 0}
        </span>
        <span className="bootcamp-chip">Registered {safeSummary.registered || 0}</span>
        <span className="bootcamp-chip">No Show {safeSummary.noShow || 0}</span>
        <span className="bootcamp-chip">Failed {safeSummary.failed || 0}</span>
        <span className="bootcamp-chip">Requires Follow-up {safeSummary.requiresFollowup || 0}</span>
      </div>

      <section
        className={`bootcamp-card bootcamp-table-card bootcamp-individual-table-card ${
          isLoading && hasRows ? 'bootcamp-table-is-refreshing' : ''
        }`}
      >
        <h3>Individual Participant Status</h3>
        {isLoading && hasRows && (
          <div className="bootcamp-refresh-banner bootcamp-refresh-banner-inline" role="status" aria-live="polite">
            Updating participant statuses...
          </div>
        )}
        <div className="bootcamp-table-wrap bootcamp-analytics-table-wrap">
          <table className="bootcamp-table bootcamp-modern-table">
            <thead>
              <tr>
                <th>Participant</th>
                <th>Company</th>
                <th>Org</th>
                <th>Region</th>
                <th>Country</th>
                <th>Bootcamp Date / Cohort</th>
                <th>Attendance</th>
                <th>BMC Helix Champion</th>
                <th>Certification Status</th>
              </tr>
            </thead>
            <tbody>
              {showInitialLoading && (
                <tr>
                  <td colSpan={9} className="bootcamp-table-loading-cell">
                    Loading participant statuses...
                  </td>
                </tr>
              )}
              {!showInitialLoading && errorMessage && !hasRows && (
                <tr>
                  <td colSpan={9} className="bootcamp-table-loading-cell">
                    {errorMessage}
                  </td>
                </tr>
              )}
              {hasRows &&
                safeRows.map((row) => (
                  <tr key={row.id}>
                  <td>
                    <div className="bootcamp-participant-cell">
                      <strong>{row.fullName}</strong>
                      <span>{row.emailAddress}</span>
                    </div>
                  </td>
                  <td title={row.company} className="bootcamp-cell-truncate">
                    {row.company}
                  </td>
                  <td>{row.org}</td>
                  <td>{row.region}</td>
                  <td>{row.country}</td>
                  <td>{row.cohort}</td>
                  <td>{row.attendance}</td>
                  <td>{row.bmcHelixChampion}</td>
                  <td>
                    <span className={`bootcamp-status-pill ${STATUS_CLASS_MAP[row.certification] || ''}`}>
                      {row.certification}
                    </span>
                  </td>
                </tr>
                ))}
            </tbody>
          </table>
        </div>

        <div className="bootcamp-pagination">
          <button
            type="button"
            className="bootcamp-pagination-btn"
            disabled={currentPage === 1 || isLoading}
            onClick={() => onPageChange(Math.max(currentPage - 1, 1))}
          >
            Previous
          </button>
          <span>
            Showing {start}–{end} of {totalItems} participants
          </span>
          <button
            type="button"
            className="bootcamp-pagination-btn"
            disabled={currentPage >= totalPages || isLoading}
            onClick={() => onPageChange(Math.min(currentPage + 1, totalPages))}
          >
            Next
          </button>
        </div>
      </section>
    </div>
  );
};

export default BootcampIndividualStatusTab;
